export default {
  // countCells: 5,
  countCells: 4,
  massive: [
    {
      dataField: 'founder',
      cols: 1,
      rows: 1,
      text: 'Центры ответственности',
      class: 'd-flex align-center  ',
      headerClass: '  ',
      // styles: 'min-width: 510px;',
      headerStyles: `min-width: 510px;`,
      order: 0,
      variable: true,
      // template: r => r?.founder?.name
      template: (r) => ((r?.name ?? '') + '<br>' + `<span class="help-text">${r.coUgsList?.map(el => el.ugsCode).join(', ')}</span>`)
    },
    {
      dataField: 'fio',
      cols: 1,
      rows: 1,
      text: `Ответственный`,
      class: ` pl-2 `,
      headerClass: ' ',
      headerStyles: `min-width:110px;`,
      // styles: 'min-width:110px;',
      order: 1,
      variable: true,
      // template: r => r?.fio
      template: r => r.contact.length ? `${r.contact[0]?.fio}<br><span class="font-size-extra-small">${r.contact[0]?.position}</span><br>
${r.contact[1]?.fio ?? ''}<br><span class="font-size-extra-small">${r.contact[1]?.position ?? ''}</span>` : '',
    },
    {
      dataField: 'numbers',
      cols: 1,
      rows: 1,
      text: `Телефоны`,
      class: `d-flex flex-column  justify-center  pl-2 `,
      headerClass: ' ',
      headerStyles: `min-width:110px;`,
      // styles: 'min-width:110px;',
      order: 2,
      variable: true,
    },
    {
      dataField: 'email',
      cols: 1,
      rows: 1,
      order: 3,
      variable: true,
      class: `d-flex  flex-column  justify-center `,
      headerStyles: `min-width:110px;`,
      // styles: 'min-width:110px;',
      headerClass: '',
      text: `Электронная почта`,
    },
    // {
    //   dataField: 'filesDto',
    //   cols: 1,
    //   rows: 1,
    //   text: `Файлы`,
    //   class: `d-flex flex-column  justify-start  pl-2 `,
    //   headerClass: ' ',
    //   headerStyles: ``,
    //   order: 4,
    //   variable: true,
    // },
  ]
}
